import { z } from "zod";
//#region src/version-compatibility.schemas.ts
/** Zod schemas for fixture/platform version compatibility constraints. */
/** Semver range string — light validation; full semver shape lives downstream. */
const VersionRangeSchema = z.string().min(1);
const FixturePlatformConstraintSchema = z.object({
	fixtureName: z.string().min(1),
	platformVersion: VersionRangeSchema
}).strict();
//#endregion
export { FixturePlatformConstraintSchema, VersionRangeSchema };

//# sourceMappingURL=version-compatibility.schemas.js.map